import moment from 'moment';
import ReactMoment from 'react-moment';
import 'moment/locale/fi';

moment.locale('fi');
ReactMoment.globalMoment = moment;
ReactMoment.globalLocale = 'fi';
ReactMoment.globalFormat = 'D.M.YYYY HH:mm:ss';
